import { Controller } from "@hotwired/stimulus"

// Toggles between preview text and full disclaimer text.
// Targets: preview (the truncated view), full (the expanded view), moreLink (the "more" toggle).
// On connect, hides the "more" link if the preview text isn't actually truncated (fits in one line).
export default class extends Controller {
  static targets = ["preview", "full", "moreLink"]

  connect() {
    this.hideMoreIfNotTruncated()
  }

  expand(event) {
    event.preventDefault()
    this.previewTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
  }

  collapse(event) {
    event.preventDefault()
    this.fullTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
  }

  hideMoreIfNotTruncated() {
    const clamped = this.previewTarget.querySelector(".line-clamp-1")
    if (!clamped) return
    if (clamped.scrollHeight <= clamped.clientHeight + 1) {
      if (this.hasMoreLinkTarget) {
        this.moreLinkTarget.classList.add("hidden")
      }
    }
  }
}
